import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito equipo de gimnasio?',
  a: 'No, todo se hace con el peso de tu cuerpo y una pared.'
}, {
  q: '¿Tengo que dejar de comer lo que me gusta?',
  a: 'Aprenderás a elegir lo mejor en cualquier situación, incluso en restaurantes de comida rápida.'
}, {
  q: '¿Cuánto tiempo me quitará al día?',
  a: 'Menos de 15 minutos en total entre ejercicios y rituales.'
}, {
  q: '¿Es seguro si tengo dolor de espalda?',
  a: 'Sí, el método OMH es de bajo impacto y fortalece el core.'
}, {
  q: '¿Recibo el producto físicamente?',
  a: 'Es un producto digital de descarga inmediata en PDF.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-6 bg-brand-dark" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-31">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-brand-text uppercase" data-id="element-32">
            Preguntas <span className="text-brand-accent" data-id="element-33">Frecuentes</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className={`border rounded-lg overflow-hidden transition-colors duration-300 ${isOpen ? 'border-brand-accent bg-brand-surface' : 'border-brand-card bg-brand-card'}`} data-id="element-35">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent" aria-expanded={isOpen} data-id="element-36">
                  <span className={`font-heading font-bold text-xl uppercase pr-4 ${isOpen ? 'text-brand-accent' : 'text-brand-text'}`} data-id="element-37">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-accent' : 'text-brand-muted'}`} aria-hidden="true" data-id="element-38" />
                </button>

                <AnimatePresence initial={false} data-id="element-39">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-40">
                      <div className="p-6 pt-0 font-body text-brand-muted leading-relaxed" data-id="element-41">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}